/* eslint-disable */
import { StyleSheet, Dimensions } from 'react-native'
import { Fonts } from '../../Themes'
export default StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row'
  },
  outerInput: {
    // shadowColor: 'rgba(0, 0, 0, 0.7)',
    // shadowOffset: {
    //   width: 0,
    //   height: 1
    // },

    // shadowRadius: 1,
    // shadowOpacity: 1,
    flex: 1
  },

  textInputLink: {
    paddingLeft: 10,
    margin: 5,
    height: 35,
    borderColor: 'rgba(79, 82, 113,1)',
    borderRadius: 5,
    borderWidth: 1,
    flex: 0.7,
    fontSize: 12,
    fontFamily: Fonts.style.font.light,
    lineHeight : 35
  },
  tconContainer: {
   marginRight: 15,
    height: 35,
    width: 35,
    borderColor: '#8692b7',
    borderWidth: 1,
    justifyContent: 'center',
    alignItems: 'center'
  },
  tconBorder: {
    width: 30,
    height: 30
  }
})
